import { render, staticRenderFns } from "./reportStatus.vue?vue&type=template&id=4b865d69&scoped=true"
import script from "./reportStatus.vue?vue&type=script&lang=js"
export * from "./reportStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b865d69",
  null
  
)

export default component.exports